export const floorTextureSwatches = {
    concrete: {
        swatchName: 'Concrete',
        color: '#ffffff',
        opacity: 1,
        thumbnailUrl: '/thumbnails/concrete.jpg',
        baseMapUrl: '/textures/concrete/concrete_texture.jpg',
        normalMapUrl: '/textures/concrete/concrete_normal.jpg',
        roughnessMapUrl: '/textures/concrete/concrete_roughness.jpg',
        tileSize: 1500
    },
    obsidian: {
        swatchName: 'Obsidian',
        color: '#91785a',
        opacity: 0.6,
        thumbnailUrl: '/thumbnails/F9304_OBSIDIAN_1.4.jpg',
        baseMapUrl: '/textures/terrazzo/terrazzo_BaseColor.jpg',
        roughnessMapUrl: '/textures/terrazzo/terrazzo_Roughness.jpg'
    },
    basalt: {
        swatchName: 'Basalt',
        color: '#787c91',
        opacity: 0.6,
        thumbnailUrl: '/thumbnails/F9309_BASALT_1.4.jpg',
        baseMapUrl: '/textures/terrazzo/terrazzo_BaseColor.jpg',
        roughnessMapUrl: '/textures/terrazzo/terrazzo_Roughness.jpg'
    },
    cabinFever: {
        swatchName: 'Cabin Fever',
        color: '#fff7ee',
        opacity: 0.5,
        thumbnailUrl: '/thumbnails/FB-127_CABINFEVER_1.4.jpg',
        baseMapUrl: '/textures/terrazzo/terrazzo_BaseColor.jpg',
        roughnessMapUrl: '/textures/terrazzo/terrazzo_Roughness.jpg'
    },
    orbit: {
        swatchName: 'Orbit',
        color: '#e6eeff',
        opacity: 1,
        thumbnailUrl: '/thumbnails/FB-310_ORBIT_1.4.jpg',
        baseMapUrl: '/textures/terrazzo/terrazzo_BaseColor.jpg',
        roughnessMapUrl: '/textures/terrazzo/terrazzo_Roughness.jpg'
    },
    domino: {
        swatchName: 'Domino',
        color: '#ffffff',
        opacity: 1,
        thumbnailUrl: '/thumbnails/FB-411_DOMINO_1.4.jpg',
        baseMapUrl: '/textures/terrazzo/terrazzo_BaseColor.jpg',
        roughnessMapUrl: '/textures/terrazzo/terrazzo_Roughness.jpg'
    },
    gravel: {
        swatchName: 'Gravel',
        color: '#e9f3ff',
        opacity: 0.6,
        thumbnailUrl: '/thumbnails/FB-414_GRAVEL_1.4.jpg',
        baseMapUrl: '/textures/terrazzo/terrazzo_BaseColor.jpg',
        roughnessMapUrl: '/textures/terrazzo/terrazzo_Roughness.jpg'
    },
    shoreline: {
        swatchName: 'Shoreline',
        color: '#d4af65',
        opacity: 0.5,
        thumbnailUrl: '/thumbnails/FB-421_SHORELINE_1.4.jpg',
        baseMapUrl: '/textures/terrazzo/terrazzo_BaseColor.jpg',
        roughnessMapUrl: '/textures/terrazzo/terrazzo_Roughness.jpg'
    },
    coyote: {
        swatchName: 'Coyote',
        color: '#fffdef',
        opacity: 0.6,
        thumbnailUrl: '/thumbnails/FB-513_COYOTE_1.4.jpg',
        baseMapUrl: '/textures/terrazzo/terrazzo_BaseColor.jpg',
        roughnessMapUrl: '/textures/terrazzo/terrazzo_Roughness.jpg'
    },
    wombat: {
        swatchName: 'Wombat',
        color: '#bcbcbc',
        opacity: 0.8,
        thumbnailUrl: '/thumbnails/FB-616_WOMBAT_1.4.jpg',
        baseMapUrl: '/textures/terrazzo/terrazzo_BaseColor.jpg',
        roughnessMapUrl: '/textures/terrazzo/terrazzo_Roughness.jpg'
    },
    nightfall: {
        swatchName: 'Nightfall',
        color: '#616b6e',
        opacity: 0.8,
        thumbnailUrl: '/thumbnails/FB-715_NIGHTFALL_1.4.jpg',
        baseMapUrl: '/textures/terrazzo/terrazzo_BaseColor.jpg',
        roughnessMapUrl: '/textures/terrazzo/terrazzo_Roughness.jpg'
    },
    creekbed: {
        swatchName: 'Creekbed',
        color: '#b7aa91',
        opacity: 0.5,
        thumbnailUrl: '/thumbnails/FB-716_CREEKBED_1.4.jpg',
        baseMapUrl: '/textures/terrazzo/terrazzo_BaseColor.jpg',
        roughnessMapUrl: '/textures/terrazzo/terrazzo_Roughness.jpg'
    },
    tidalwave: {
        swatchName: 'Tidal Wave',
        color: '#f1fbff',
        opacity: 0.6,
        thumbnailUrl: '/thumbnails/FB-807_TIDALWAVE_1.4.jpg',
        baseMapUrl: '/textures/terrazzo/terrazzo_BaseColor.jpg',
        roughnessMapUrl: '/textures/terrazzo/terrazzo_Roughness.jpg'
    }
};
export const getFloorTextureUrl = (key)=>{
    const s = floorTextureSwatches[key];
    return s?.baseMapUrl;
};
export const getFloorNormalMapUrl = (key)=>{
    const s = floorTextureSwatches[key];
    // Check for texture-specific normal map first, then fall back to default
    return s?.normalMapUrl;
};
export const getFloorRoughnessMapUrl = (key)=>{
    const s = floorTextureSwatches[key];
    // Check for texture-specific roughness map first, then fall back to default
    return s?.roughnessMapUrl;
};
export const getFloorTileSize = (key)=>{
    const s = floorTextureSwatches[key];
    return s?.tileSize;
};
export const getFloorColor = (key)=>{
    const s = floorTextureSwatches[key];
    return s?.color;
};
export const getFloorOpacity = (key)=>{
    const s = floorTextureSwatches[key];
    return s?.opacity;
};

//# sourceMappingURL=floor-textures.js.map